import { Pipe, PipeTransform } from '@angular/core';
import { Badge } from '../../../model/badge.model';

type AchievementType = Badge['type'];

const icons: Record<AchievementType, IconType | null> = {
    badge: 'badge-gradient-1',
    milestone: 'achievement',
    activity: null,
};

@Pipe({
    name: 'achievementIcon',
    standalone: false,
})
export class AchievementIconPipe implements PipeTransform {
    transform(type: 'badge' | 'milestone' | 'activity') {
        return icons[type];
    }
}
